import { InjectionToken } from '@angular/core';

/**
 * æ è¯å¼¹åºå±ç zIndex
 */
export const UI_OVERLAY_Z_INDEX = new InjectionToken<number>('UI_OVERLAY_Z_INDEX');
